<template>
  <v-progress-linear :indeterminate="true" :class="progressClass" color="accent"></v-progress-linear>
</template>

<script>
export default {
  props: {
    main: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    progressClass () {
      return this.main ? 'pi-progress pi-progress-main' : 'pi-progress'
    }
  }
}
</script>

<style scoped>
.pi-progress {
  margin:0;
  position: absolute;
}
.pi-progress-main {
  top: 0;
  left: 0;
}
</style>
